<template>
  <div class="data-grid-file-upload">
    <el-upload ref="dataGridFileUpload"
               :class="{'exceed-upload-state': uploading || uploadFile.link}"
               drag
               :limit="1"
               :before-upload="beforeFileUpload"
               :on-success="handleFileUploadSuccess"
               :on-error="handleFileUploadError"
               :on-preview="handleFileUploadPreview"
               :on-remove="handleFileUploadRemove"
               list-type="text"
               name="uploadFile"
               :http-request="httpRequest"
               :action="uploadAction"
               :data="uploadParams"
               :accept="uploadAccept"
               :file-list="fileList">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        <span v-if="fileSuffix && fileSuffix.length">
          只能上传{{fileSuffix.join('、')}}类型文件，且不能超过{{maxFileSize | formatFileSize}}
        </span>
        <span v-else>
          文件大小不能超过{{maxFileSize | formatFileSize}}
        </span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import Support from '../../../mixins/support'
import Emitter from 'element-ui/lib/mixins/emitter'
import ElUpload from '../../../mixins/upload/ElUpload'
import baseApiUrl from '../../../constants/baseApiUrl'
export default {
  mixins: [Support, Emitter, ElUpload],
  name: 'DataGridFileUpload',
  props: {
    value: {
      required: true
    },
    filename: {
      type: String
    },
    acceptType: {
      type: Object
    },
    maxFileSize: {
      type: Number,
      default: 500 * 1024 * 1024
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      uploading: false,
      fileList: [],
      uploadFile: {
        name: null,
        link: null
      }
    }
  },
  computed: {
    uploadAction: function () {
      return this.$contextPath(baseApiUrl.DataGridUrl)
    },
    uploadParams: function () {
      return this.$extend({
        requestType: 'upload',
        prop: this.column.prop
      }, this.$attrs)
    },
    uploadAccept: function () {
      if (this.fileSuffix && this.fileSuffix.length) {
        return this.fileSuffix.join(',')
      }
    },
    fileSuffix: function () {
      let suffix
      if (this.acceptType && this.acceptType.validators) {
        this.acceptType.validators.some((validator) => {
          if (validator.type === 'suffix') {
            let validate = validator.validate
            suffix = validate.suffix
            if (suffix && suffix.length > 0) {
              return suffix
            }
          }
        })
      }
      return suffix
    }
  },
  methods: {
    beforeFileUpload (file) {
      if (this.fileSuffix && this.fileSuffix.length > 0) {
        let filename = file.name
        let index = filename.lastIndexOf('.')
        if (index > 0) {
          let suffix = filename.substring(index).toLowerCase()
          if (!this.fileSuffix.includes(suffix)) {
            this.$message.error('上传的文件格式不合法')
            return false
          }
        } else {
          this.$message.error('上传的文件格式不合法')
          return false
        }
      }
      if (file.size <= this.maxFileSize) {
        this.uploading = true
        return true
      } else {
        this.$message.error('上传的文件大小超过限制')
        return false
      }
    },
    handleFileUploadSuccess (res) {
      this.uploading = false
      if (res['responseCode'] === 'SUCCESS') {
        this.uploadFile.name = res['fileName']
        this.uploadFile.link = res['fileUrl']
        this.$emit('input', this.uploadFile.link)
        this.$emit('change', this.uploadFile.link)
        this.$emit('update:filename', this.uploadFile.name)
        this.dispatch('ElFormItem', 'el.form.change', this.uploadFile.link)
      } else {
        this.$message.error(res.message || '获取返回信息失败')
      }
    },
    handleFileUploadError () {
      this.uploading = false
      this.clearUploadFile()
      this.$message.error('文件上传失败')
    },
    handleFileUploadPreview () {
      if (this.uploadFile.link) {
        window.open(this.$contextPath(this.uploadFile.link))
      }
    },
    handleFileUploadRemove () {
      this.clearUploadFile()
    },
    clearUploadFile () {
      this.uploadFile.name = null
      this.uploadFile.link = null
      this.$emit('input', '')
      this.$emit('change', '')
      this.$emit('update:filename', '')
      this.dispatch('ElFormItem', 'el.form.change', '')
    }
  },
  watch: {
    value: function (newValue) {
      if (newValue) {
        this.uploadFile.name = this.filename
        this.uploadFile.link = newValue
        this.fileList = [{
          name: this.uploadFile.name || `${this.column.name}（文件）`,
          url: this.$contextPath(newValue)
        }]
        this.$emit('update:filename', this.uploadFile.name)
      } else {
        this.clearUploadFile()
        let dataGridFileUpload = this.$refs['dataGridFileUpload']
        if (dataGridFileUpload) {
          dataGridFileUpload.clearFiles()
        }
      }
    },
    filename: function (newValue) {
      if (!newValue) {
        this.clearUploadFile()
      }
    }
  }
}
</script>

<style lang="scss">
  .el-form-item {
    &.is-success {
      .data-grid-file-upload {
        .el-upload {
          .el-upload-dragger {
            border-color: #67c23a;
          }
        }
      }
    }
    &.is-error {
      .data-grid-file-upload {
        .el-upload {
          .el-upload-dragger {
            border-color: #f56c6c;
          }
        }
      }
    }
    .data-grid-file-upload {
      * {
        transition: none!important;
      }
      .exceed-upload-state {
        .el-upload {
          display: none;
        }
        .el-upload__tip {
          display: none;
        }
        .el-upload-list {
          &.el-upload-list--text {
            .el-upload-list__item {
              padding-left: 5px;
              line-height: 30px;
              border: 1px solid #dcdfe6;
              background-color: #fff;
              box-sizing: border-box;
              &:first-child {
                margin-top: 0;
              }
              .el-upload-list__item-name {
                font-size: 12px;
              }
              .el-icon-close {
                top: 0;
                line-height: 30px;
              }
              .el-progress {
                width: auto;
                left: 5px;
                right: 5px;
              }
            }
          }
        }
      }
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 80px;
          border-style: solid;
          border-radius: 4px;
          .el-icon-upload {
            margin-top: 12px;
            margin-bottom: 0;
            font-size: 30px;
            line-height: 30px;
          }
          .el-upload__text {
            font-size: 12px;
            line-height: 1;
          }
        }
      }
      .el-upload__tip {
        margin-top: -5px;
        color: #909399;
        line-height: 24px;
      }
    }
  }
</style>
